'use client'

// import { socialUserFeedQueryFetcher } from '@web/gen/feed'
import { RightSidebar } from '../../../masterfeed/_components/right-sidebar'
// import { useQuery } from '@tanstack/react-query'
// import { useGetMyAccountUserProfileQuery } from '@web/gen/cf'
import { useClubhousesFromUserQuery } from '@web/gen/crafter'
import { usePublicUserProfileQuery } from '@web/gen/user'
// import { useUser, useUserIsDesigner, useUserIsTeacher } from '@repo/cf-user/hooks/use-user-data'
import { getClubhouseDetails } from '@web/app/[locale]/clubhouse/_components/constants'
import { tw } from 'utils/classnames'
import * as React from 'react'
import type { Clubhouse, PublicUserProfile, User } from 'codegen/types'
// import { useClubhouseOnlineCount } from '@web/app/[locale]/clubhouse/_hooks/use-clubhouse-online-count'
import { formatString } from '@web/app/[locale]/clubhouse/_utils/format-string'
import { UserAvatar } from '@web/app/[locale]/clubhouse/[slug]/_components/top-banner/_components/user-avatar'
// import { ClubhouseCard } from '@web/app/[locale]/clubhouse/_components/clubhouse-card'
import Image from 'next/image'
import { useUserQuery, useIsLoggedInQuery } from 'auth/hooks'
// import { useGetYourMachines } from '../_hooks'
import { Button } from '@repo/design-system-cf/components/button'
import { Link } from '@repo/web-ui/components/link'
import { AppRoutes } from '@repo/web-utils/app-routes'
import { useClubhousesListAllQuery } from '@web/gen/clubhouses'
import { SkeletonItem } from 'components/skeleton-item'
import { formatUserName } from 'utils/format-user-name'
import { decodeHtmlEntities } from 'utils/decode-html-entities'
import { useTranslations } from 'next-intl'
import { IconPersonPin } from '@repo/design-system-cf/components/icons'

export const AboutContent = ({ slug }: { slug: string }) => {
  const t = useTranslations('social-feed.page.crafter_profile')
  const { data: user } = useUserQuery(undefined, {
    select: data => data.me?.user,
  })

  const isLoggedInQuery = useIsLoggedInQuery()

  const { data: publicProfile, isPending: isPublicProfilePending } = usePublicUserProfileQuery(
    { slug: slug ?? '' },
    { select: d => d?.publicUserProfile, enabled: Boolean(slug) },
  )

  const { data: clubhouses, isPending: isClubhousesPending } = useClubhousesFromUserQuery(
    {
      input: { userId: publicProfile?.id ?? '', page: 0, itemsPerPage: 15 },
    },
    {
      select: data => data?.clubhousesFromUser?.clubhouses,
      enabled: Boolean(publicProfile?.id),
    },
  )

  const isSelf = user?.slug === slug

  const userFullName = formatUserName(
    publicProfile?.firstName,
    publicProfile?.lastName,
    'User',
    decodeHtmlEntities,
  )

  if (isLoggedInQuery.isPending || isPublicProfilePending || isClubhousesPending) {
    return (
      <div className="flex w-full">
        <div className="min-w-0 flex-1 basis-0">
          <div className="flex flex-col w-full">
            <div className="flex items-center mt-6 justify-between mb-3">
              <div className="flex items-center justify-start gap-2">
                <SkeletonItem className="w-32 h-6 rounded" />
              </div>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2">
              <SkeletonItem className="w-full h-[96px] rounded-[12px]" />
              <SkeletonItem className="w-full h-[96px] rounded-[12px]" />
              <SkeletonItem className="w-full h-[96px] rounded-[12px]" />
            </div>
          </div>
        </div>
        <RightSidebar className="ml-6 mt-5" showDownloads={false} />
      </div>
    )
  }

  if (
    !isLoggedInQuery.isPending &&
    !isLoggedInQuery.data &&
    (!clubhouses || clubhouses?.length === 0) &&
    !isClubhousesPending
  ) {
    return (
      <div className="flex w-full">
        <div className="bg-cf-white border border-cf-transparent-grey-1000-12 rounded-[12px] p-6 w-full flex flex-col items-center justify-start">
          <IconPersonPin className="size-10 text-cf-purple-900" />
          <p className="text-20 font-bold text-center text-cf-grey-1000 my-4">
            {t('no_about_page_text', { userFullName })}
          </p>
        </div>
        <RightSidebar className="ml-6 " showDownloads={false} />
      </div>
    )
  }

  return (
    <div className="flex w-full">
      <div className="min-w-0 flex-1 basis-0">
        <div className="flex flex-col w-full">
          {/* <AboutContentItem isSelf={isSelf} slug={slug} /> */}
          {/* <MachinesContentItem isSelf={isSelf} slug={slug} /> */}
          <ClubhouseContentItem
            isSelf={isSelf}
            me={user as User}
            userId={publicProfile?.id ?? ''}
            publicProfile={publicProfile as PublicUserProfile}
            isPublicProfilePending={isPublicProfilePending}
          />
        </div>
      </div>

      <RightSidebar className="ml-6 mt-5" showDownloads={false} />
    </div>
  )
}
// TO-DO when data is available
// const AboutContentItem = ({ isSelf, slug }: { isSelf: boolean; slug: string }) => {
//   const { data: publicProfile } = usePublicUserProfileQuery(
//     { slug: slug ?? '' },
//     { select: d => d?.publicUserProfile, enabled: Boolean(slug) },
//   )

//   return (
//     <>
//       <div className="bg-cf-white border mt-4 border-[#1313151F] rounded-[12px] p-6 ">
//         <h3 className="text-20 font-bold text-cf-grey-1000">{'Bio'}</h3>
//         <p className="mt-3 text-14 font-normal text-cf-grey-800">{publicProfile?.bio}</p>
//       </div>
//     </>
//   )
// }

// const MachinesContentItem = ({ isSelf, slug }: { isSelf: boolean; slug: string }) => {
//   const { machineTypes, machinesMap, craftingTypes, craftingsMap } = useGetYourMachines(slug)

//   console.log(machineTypes, machinesMap, craftingTypes, craftingsMap)

//   return (
//     <>
//       <div className="flex mt-6 items-center justify-start gap-2">
//         <h3 className="text-20 font-bold text-cf-grey-1000">{'Machines'}</h3>
//         <div className="size-6 bg-cf-grey-200 rounded-full  flex items-center border border-[#1313151F] justify-center">
//           <p className="text-12 font-semibold text-cf-grey-500">{'5'}</p>
//         </div>
//       </div>
//       <div className="grid grid-cols-3 mt-3 gap-2">
//         {[
//           { id: 1, name: 'Machine 1' },
//           { id: 2, name: 'Machine 2' },
//           { id: 3, name: 'Machine 3' },
//           { id: 4, name: 'Machine 4' },
//           { id: 5, name: 'Machine 5' },
//         ].map(machine => (
//           <div
//             key={machine.id}
//             className="bg-cf-white border border-[#1313151F] rounded-[12px] min-h-[60px] p-6"
//           >
//             <h4 className="text-16 font-semibold text-cf-grey-1000">{machine.name}</h4>
//           </div>
//         ))}
//       </div>
//     </>
//   )
// }

// oxlint-disable-next-line complexity
const ClubhouseContentItem = ({
  userId,
  me,
  isSelf,
  isPublicProfilePending,
  publicProfile,
}: {
  userId: string
  me: User
  isSelf: boolean
  isPublicProfilePending: boolean
  publicProfile: PublicUserProfile
}) => {
  const t = useTranslations('social-feed.page.crafter_profile')
  const { data: clubhouses, isPending: isClubhousesPending } = useClubhousesFromUserQuery(
    {
      input: { userId, page: 0, itemsPerPage: 15 },
    },
    {
      select: data => data?.clubhousesFromUser?.clubhouses,
    },
  )

  const clubhousesWithIcons = React.useMemo(
    () =>
      clubhouses?.map(clubhouse => ({
        ...clubhouse,
        icon: getClubhouseDetails(clubhouse.slug)?.icon,
      })),
    [clubhouses],
  )

  const { data: recommendedClubhouses, isPending: isRecommendedPending } =
    useClubhousesListAllQuery(
      {
        page: 1,
        itemsPerPage: 3,
      },
      {
        enabled: !isPublicProfilePending && !isClubhousesPending && clubhouses === null,
      },
    )

  const recommendedClubhousesWithIcons = React.useMemo(
    () =>
      recommendedClubhouses?.clubhousesListAll.clubhouses?.map(clubhouse => ({
        ...clubhouse,
        icon: getClubhouseDetails(clubhouse.slug)?.icon,
      })),
    [recommendedClubhouses],
  )

  const { data: mineTop3Clubhouses } = useClubhousesFromUserQuery(
    {
      input: { userId: me?.id, page: 0, itemsPerPage: 3 },
    },
    {
      select: data => data?.clubhousesFromUser?.clubhouses,
      enabled: Boolean(me?.id),
    },
  )

  const mineTop3ClubhousesWithIcons = React.useMemo(
    () =>
      mineTop3Clubhouses?.map(clubhouse => ({
        ...clubhouse,
        icon: getClubhouseDetails(clubhouse.slug)?.icon,
      })),
    [mineTop3Clubhouses],
  )

  const userFullName = formatUserName(
    publicProfile?.firstName,
    publicProfile?.lastName,
    'User',
    decodeHtmlEntities,
  )

  return (
    <>
      <div className="flex items-center mt-6 justify-between mb-3">
        <div className="flex items-center justify-start gap-2">
          <h3 className="text-20 font-bold text-cf-grey-1000">{t('clubhouses')}</h3>
          <div className="size-6 bg-cf-grey-200 rounded-full flex items-center border border-[#1313151F] justify-center">
            <p className="text-12 font-semibold text-cf-grey-500">
              {clubhousesWithIcons?.length ? clubhousesWithIcons?.length : 0}
            </p>
          </div>
        </div>
        <Button variant="tertiary" size={'small'} className="hidden tablet:flex" asChild>
          <Link href={AppRoutes.CLUBHOUSE}>{t('discover_more_clubhouses')}</Link>
        </Button>
        <Button variant="tertiary" size={'small'} className="flex tablet:hidden" asChild>
          <Link href={AppRoutes.CLUBHOUSE}>{t('discover_more')}</Link>
        </Button>
      </div>

      {isPublicProfilePending || isClubhousesPending ? (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2">
          <SkeletonItem className="w-full h-[96px] rounded-[12px]" />
          <SkeletonItem className="w-full h-[96px] rounded-[12px]" />
          <SkeletonItem className="w-full h-[96px] rounded-[12px]" />
        </div>
      ) : null}
      {clubhousesWithIcons && clubhousesWithIcons?.length > 0 ? (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2">
          {clubhousesWithIcons?.map(clubhouse => (
            <ClubhouseCardSmall clubhouse={clubhouse as Clubhouse} key={clubhouse.slug} />
          ))}
        </div>
      ) : null}
      {isSelf &&
      !isPublicProfilePending &&
      !isClubhousesPending &&
      !isRecommendedPending &&
      recommendedClubhousesWithIcons &&
      recommendedClubhousesWithIcons.length > 0 ? (
        <div className="flex flex-col justify-start">
          <p className="text-14 font-normal text-cf-grey-800 max-w-2xl">
            {t('no_clubhouses_text')}
          </p>
          <p className="text-16 font-semibold text-cf-grey-1000 mt-5">{'Recommended for you'}</p>
          <div className="grid mt-3 grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2">
            {recommendedClubhousesWithIcons.map(clubhouse => (
              <ClubhouseCardSmall clubhouse={clubhouse as Clubhouse} key={clubhouse.slug} />
            ))}
          </div>
        </div>
      ) : null}
      {!isSelf &&
      !isPublicProfilePending &&
      !isClubhousesPending &&
      !isRecommendedPending &&
      mineTop3ClubhousesWithIcons &&
      mineTop3ClubhousesWithIcons.length > 0 ? (
        <div className="flex flex-col justify-start">
          <p className="text-14 font-normal text-cf-grey-800 max-w-2xl">
            {t('no_clubhouses_text_with_user', { userFullName })}
          </p>
          <p className="text-16 font-semibold text-cf-grey-1000 mt-5">
            {t('invite_to_clubhouses_text')}
          </p>
          <div className="grid mt-3 grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2">
            {mineTop3ClubhousesWithIcons?.map(clubhouse => (
              <ClubhouseCardSmall
                clubhouse={clubhouse as Clubhouse}
                invite={true}
                key={clubhouse.slug}
              />
            ))}
          </div>
        </div>
      ) : null}
    </>
  )
}

const ClubhouseCardSmall = ({
  clubhouse,
  invite = false,
}: {
  clubhouse: Clubhouse
  invite?: boolean
}) => {
  return (
    <Link
      key={clubhouse.slug}
      className="bg-cf-white border border-[#1313151F] rounded-[12px] min-h-[96px] flex flex-row items-center justify-between p-4 hover:shadow-[0_1px_1px_0_#1313151F,_0_2px_4px_2px_#1313151F] active:shadow-none"
      href={`${AppRoutes.CLUBHOUSE}${clubhouse.slug}`}
    >
      <div className="flex-col">
        <h4 className="text-16 font-semibold text-cf-grey-1000">{clubhouse.name}</h4>
        <p className="text-cf-sf-gray-1150 text-12">{formatString(clubhouse.type)}</p>
        {invite ? (
          <Button variant="tertiary" size={'small'} className="mt-3" asChild>
            <Link href={`${AppRoutes.CLUBHOUSE}${clubhouse.slug}/members/invite/`}>{'Invite'}</Link>
          </Button>
        ) : (
          <div className="flex flex-row items-center gap-2 mt-3">
            <div className="flex flex-row">
              <UserAvatar size="small" displayCount={3} slug={clubhouse.slug} />
            </div>

            <p className="text-12 font-semibold leading-4">{clubhouse.membersTotal + ' Members'}</p>
          </div>
        )}
      </div>
      <div
        className={tw(
          'flex h-[40px] w-[40px] shrink-0 items-center justify-center rounded-full',
          clubhouse.bgColor ? `bg-[${clubhouse?.bgColor}]` : 'bg-cf-white',
        )}
      >
        <Image src={clubhouse?.avatarImage || ''} alt="logo" width={40} height={40} />
      </div>
    </Link>
  )
}
